module.exports = __webpack_public_path__ + "media/components/assets/img/bg/noise-1-89ca1b9632a8d92867c53a20fe376621.svg";